export default __webpack_public_path__ + "static/media/qr-code-infinity.b4c6bdd0.svg";